import Main from './TrainningJourneyMain'

export default {
  Main,
}
